import { queryOptions } from '@tanstack/react-query';

import { getDetailedPortfolioHistoryWindowData } from './get-detailed-portfolio-history-window-data.ts';
import { getPortfolioLayoutData } from './get-portfolio-layout-data.ts';
import { getPortfolioPageData } from './get-portfolio-page-data.ts';
import { getPortfolioTransactionsPageData } from './get-portfolio-transactions-page-data.ts';

export const PORTFOLIO_DETAILED_HISTORY_WINDOW_DAYS = 180;

export function getPortfolioLayoutQueryOptions() {
	return queryOptions({
		queryFn: () => getPortfolioLayoutData(),
		queryKey: ['portfolio', 'layout'] as const,
		staleTime: 15 * 60 * 1000,
	});
}

export function getPortfolioQueryKey(portfolioId: number): readonly ['portfolio', number] {
	return ['portfolio', portfolioId];
}

export function getPortfolioOverviewQueryOptions(portfolioId: number) {
	return queryOptions({
		queryFn: () => getPortfolioPageData({ data: { portfolioId } }),
		queryKey: [...getPortfolioQueryKey(portfolioId), 'overview'] as const,
	});
}

export function getPortfolioDetailedHistoryWindowQueryKey(
	portfolioId: number,
	fromTimestamp: number,
	toTimestamp: number,
) {
	return [...getPortfolioQueryKey(portfolioId), 'detailed-history-window', fromTimestamp, toTimestamp] as const;
}

export function getPortfolioDetailedHistoryWindowQueryOptions(
	portfolioId: number,
	fromTimestamp: number,
	toTimestamp: number,
) {
	return queryOptions({
		queryFn: () =>
			getDetailedPortfolioHistoryWindowData({
				data: {
					fromTimestamp,
					portfolioId,
					toTimestamp,
				},
			}),
		queryKey: getPortfolioDetailedHistoryWindowQueryKey(portfolioId, fromTimestamp, toTimestamp),
	});
}

export function getPortfolioTransactionsQueryOptions(portfolioId: number) {
	return queryOptions({
		queryFn: () => getPortfolioTransactionsPageData({ data: { portfolioId } }),
		queryKey: [...getPortfolioQueryKey(portfolioId), 'transactions'] as const,
		staleTime: 15 * 60 * 1000,
	});
}
